/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { GuideCell as IGuideCell, ContentType } from 'client-code/grid-guide';
import { POSTER_IMAGE_NAME, POSTER_IMAGE_DIMENSION } from '../strings';

export class GuideCell {
    /**
     * Collection ID for a given guide cell.
     * @type {string}
     */
    collectionId: string;

    /**
     * Content ID for a given guide cell.
     * @type {string}
     */
    contentId: string;

    /**
     * The type of content.
     * @type {ContentType}
     */
    contentType?: ContentType;

    /**
     * Showing duration in seconds.
     * @type {number}
     */
    duration: number;

    /**
     * When true, showing should be treated as adult.
     * @type {boolean}
     */
    isAdult?: boolean;

    /**
     * When true, showing should be treated as new.
     * @type {boolean}
     */
    isNew?: boolean;

    /**
     * When true, showing supports PPV.
     * @type {boolean}
     */
    isPPV?: boolean;

    /**
     * The year the movie was released.
     * @type {number}
     */
    movieYear?: number;

    /**
     * Offer ID for a given guide cell.
     * @type {string}
     */
    offerId: string;

    /**
     * Showing start time as Date object.
     * @type {Date}
     */
    startTime: Date;

    /**
     * Showing title.
     * @type {string}
     */
    title?: string;

    /**
     * When true, showing supports start-over.
     * @type {boolean}
     */
    isStartover?: boolean;

    /**
     * When true, showing supports catch-up.
     * @type {boolean}
     */
    isCatchup?: boolean;

    /**
     * When true, showing can be recorded.
     * @type {boolean}
     */
    isRecordable?: boolean;

    /**
     * poster image url
     * @type {string}
     */
    posterImageUrl: string;

    constructor(guideCell: IGuideCell, imageHostBaseUrl: string) {
        this.collectionId = guideCell.collectionId;
        this.contentId = guideCell.contentId;
        this.contentType = guideCell.contentType;
        this.duration = guideCell.duration;
        this.isAdult = guideCell.isAdult;
        this.isNew = guideCell.isNew;
        this.isPPV = guideCell.isPPV;
        this.isRecordable = guideCell.isRecordable;
        this.movieYear = guideCell.movieYear;
        this.offerId = guideCell.offerId;
        this.startTime = new Date(guideCell.startTime * 1000);
        this.title = guideCell.title;
        this.isStartover = guideCell.isStartover;
        this.isCatchup = guideCell.isCatchup;
        this.posterImageUrl = `${imageHostBaseUrl}/images/${guideCell.collectionId}/${POSTER_IMAGE_NAME}${POSTER_IMAGE_DIMENSION}`;
    }
}
